module.exports = __webpack_public_path__ + "static/media/skill5_neg_en.361d2f85.txt";